module.exports = __webpack_public_path__ + "img/logo.63f1dd76.svg";